import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { appUrls } from '../../../utils/urls/appUrls'

export default function DigitalLetterSidebar() {
    const [openNavBar, setOpenNavBar] = useState(false)
    const { digitalLetterManagement:{ activeEmailTab, inboxLetters } } = useSelector((state) => state.app);

    const unreadInbox = useMemo(() => {
      return inboxLetters.filter((letter) => letter.IS_NEW === 1).length;
    }, [inboxLetters]);

    return (
      <div className="col-lg-4 col-xl-3 col-xxl-2">
        <div className='px-3 py-2'>
          <button className='d-block d-lg-none' onClick={() => setOpenNavBar((previous) => !previous)}>
            <i className='mdi mdi-menu'></i>
            <span className="sr-only">Toggle navigation</span>
          </button>
        </div>

        <div className={`${openNavBar ? 'd-block' : 'd-none'} d-none d-lg-block email-left-column email-options p-4 p-xl-5`}>
          <Link to={`${appUrls.digitalLetterBase}?tab=compose`} className="btn btn-block btn-primary btn-pill mb-4 mb-xl-5">Compose</Link>
          
          <ul className="pb-2">
            <li className={`d-block mb-4 ${activeEmailTab === 'inbox' ? 'active' : ''}`}>
              <Link to={`${appUrls.digitalLetterBase}?tab=inbox`}>
              <i className="mdi mdi-download mr-2"></i> Inbox</Link>
              {unreadInbox > 0 && <span className="badge badge-secondary">{unreadInbox}</span>}
            </li>
      
            <li className={`d-block mb-4 ${activeEmailTab === 'draft' ? 'active' : ''}`}>
              <Link to={`${appUrls.digitalLetterBase}?tab=draft`}>
              <i className="mdi mdi-playlist-edit mr-2"></i> Drafts</Link>
            </li>

            <li className={`d-block mb-4 ${activeEmailTab === 'sent' ? 'active' : ''}`}>
              <Link to={`${appUrls.digitalLetterBase}?tab=sent`}>
              <i className="mdi mdi-open-in-new mr-2"></i> Sent</Link>
            </li>
          </ul>
        </div>
      </div>
    );
}
